import { Injectable } from '@angular/core';
import { storeInfo, facebookId } from '../../app/settings.config';
import { DatabaseServiceProvider } from '../database-service/database-service';

@Injectable()
export class HtmlheadServiceProvider {
	locInfo: any;
	locSettings: Array<any> = [];
	locDetails: Array<any> = [];
	items: Array<any> = [];
	constructor(private afService: DatabaseServiceProvider, ) {

	}

	getData() {
		var promise = new Promise((resolve, reject) => {
			this.afService.getItemList('locations').take(1).subscribe((data) => {
				this.items = data;
				resolve(this.items);
			}, error => { reject(error); });
		});
		return promise;
	}

	clearHead() {
		// Try to remove all META-Informaiton
		this.removeDescription();
		this.removeKeywords();
		this.removeStructuredData();
		this.removeSocialMedia();
		//add common tags
		this.addStructuredDataWebSite();
		this.addStructuredDataOrganisation();
	}

	removeDescription() {
		// Try to remove META-Tags
		try {
			document.querySelector("meta[name='description']").remove();
		} catch (e) {
		}
	}

	addDescription(content) {
		// Add the new META-Tags
		var description = document.createElement('meta');
		description.name = "description";
		description.content = content;
		document.getElementsByTagName('head')[0].appendChild(description);
	}

	removeKeywords() {
		// Try to remove META-Tags
		try {
			document.querySelector("meta[name='keywords']").remove();
		} catch (e) {
		}
	}

	removeSocialMedia() {
		// Try to remove META-Tags
		try {
			document.querySelector("meta[name='og:image']").remove();
			document.querySelector("meta[name='fb:app_id']").remove();
			document.querySelector("meta[name='og:title']").remove();
			document.querySelector("meta[name='og:description']").remove();
			document.querySelector("meta[name='og:url']").remove();
			document.querySelector("meta[name='og:site_name']").remove();
			document.querySelector("meta[name='twitter:url']").remove();
			document.querySelector("meta[name='twitter:description']").remove();
			document.querySelector("meta[name='twitter:image']").remove();
		} catch (e) {

		}
	}

	addKeywords(content) {
		var keywords = document.createElement('meta');
		keywords.name = "keywords";
		keywords.content = storeInfo.storeName + ", " + storeInfo.shortName + ', ' + storeInfo.metaData.keywords + ' , ' + content;
		document.getElementsByTagName('head')[0].appendChild(keywords);
	}

	removeStructuredData() {
		// Remove all Structured Data
		try {
			while (document.querySelector("script[type='application/ld+json']")) {
				document.querySelector("script[type='application/ld+json']").remove();
			}
		} catch (e) {

		}
	}

	addStructuredDataWebSite() {
		var script = document.createElement('script');
		script.type = "application/ld+json";
		script.innerText = '{"@context": "http://schema.org","@type": "WebSite","name": "' + storeInfo.storeName + '","alternateName": "' + storeInfo.shortName + '","url": "' + storeInfo.orderUrl + '","sameAs": ["' + storeInfo.fbUrl + '","' + storeInfo.storeHomePage + '"]}';
		document.getElementsByTagName('head')[0].appendChild(script);
	}

	async addStructuredDataOrganisation() {
		if(this.items.length == 0){
			await this.getData();
		}
		var script = document.createElement('script');
		script.type = "application/ld+json";
		// script.innerText = '{"@context": "http://schema.org","@type": "Organization","url":"'+ storeInfo.orderUrl +'","logo":"'+ storeInfo.orderUrl +'img/logo.png"}';
		var textData = '{';
		textData = textData + '"@context": "http://schema.org","@type": "Organization","name":"' + storeInfo.storeName + '" ,"url":"' + storeInfo.orderUrl + '","logo":"' + storeInfo.orderUrl + 'img/logo.png", ';
		textData = textData + '"telephone":"' + storeInfo.metaData.phone + '", "email": "' + storeInfo.metaData.email + '", ';
		textData = textData + '"department": [';
		for (var i = 0; i <= this.items.length - 1; i++) {
			this.locDetails.push(this.items[i]);
		}

		for (i = 0; i <= this.locDetails.length - 1; i++) {
			try {
				var add = this.locDetails[i].address.split(",");
			} catch (error) {
				 add = this.locDetails[i].address || '';
			}
			// console.log(add)
			try {
				var zip = add[2].replace(/^\D+/g, '');
			} catch (error) {
				zip = ''
			}
			textData = textData + '{';
			textData = textData + '"@type": "Restaurant", ';
			textData = textData + '"name": "' + this.locDetails[i].name + '", ';
			textData = textData + '"image": "' + this.locDetails[i].image + '", ';
			textData = textData + '"servesCuisine": "' + this.locDetails[i].servesCuisine + '", ';
			textData = textData + '"priceRange": "' + this.locDetails[i].priceRange + '", ';
			textData = textData + '"telephone": "' + this.locDetails[i].phone + '", ';
			textData = textData + '"email": "' + this.locDetails[i].email + '", ';
			textData = textData + '"address": { ';
			textData = textData + '"@type": "PostalAddress", ';
			textData = textData + '"addressRegion": "' + add[1] + '", ';
			textData = textData + '"postalCode": "' + zip + '", ';
			textData = textData + '"streetAddress": "' + add[0] + '"}, ';
			textData = textData + '"geo" : {';
			textData = textData + '"@type" : "GeoCoordinates",';
			textData = textData + '"latitude" : "' + this.locDetails[i].latitude + '",';
			textData = textData + '"longitude" : "' + this.locDetails[i].longitude + '"';
			textData = textData + '} ';
			// 				},	"openingHours": [
			// 						"Tu-Fr 17:00-00:00",
			// 						"Sa 12:00-00:00",
			// 						"Su 12:00-21:00"
			// 					],
			// 					"email" : "demo@orders.spiceapp.us"
			// 			}
			if (i == this.locDetails.length) {
				textData = textData + '},';
			} else {
				textData = textData + '}';
			}

		}

		textData = textData + ']';
		textData = textData + '}';
		script.innerHTML = textData;
		document.getElementsByTagName('head')[0].appendChild(script);
		// });

	}

	addSocialMeta(imgUrl, title, url, description) {
		if (imgUrl == undefined) { imgUrl = storeInfo.phImgUrl; }
		var keywords;
		//opengraph tags
		keywords = document.createElement('meta');
		keywords.name = "og:image";
		keywords.content = imgUrl;
		document.getElementsByTagName('head')[0].appendChild(keywords);
		keywords = document.createElement('meta');
		keywords.name = "fb:app_id";
		keywords.content = facebookId.appId;
		document.getElementsByTagName('head')[0].appendChild(keywords);
		keywords = document.createElement('meta');
		keywords.name = "og:title";
		keywords.content = title;
		document.getElementsByTagName('head')[0].appendChild(keywords);
		keywords = document.createElement('meta');
		keywords.name = "og:description";
		keywords.content = description;
		document.getElementsByTagName('head')[0].appendChild(keywords);
		keywords = document.createElement('meta');
		keywords.name = "og:url";
		keywords.content = url;
		document.getElementsByTagName('head')[0].appendChild(keywords);
		keywords = document.createElement('meta');
		keywords.name = "og:site_name";
		keywords.content = storeInfo.shortName + ' Online Ordering';
		document.getElementsByTagName('head')[0].appendChild(keywords);
		//twitter tags
		keywords = document.createElement('meta');
		keywords.name = "twitter:url";
		keywords.content = url;
		document.getElementsByTagName('head')[0].appendChild(keywords);
		keywords = document.createElement('meta');
		keywords.name = "twitter:description";
		keywords.content = description;
		document.getElementsByTagName('head')[0].appendChild(keywords);
		keywords = document.createElement('meta');
		keywords.name = "twitter:image";
		keywords.content = imgUrl;
		document.getElementsByTagName('head')[0].appendChild(keywords);
	}

	addProductList(data: Array<any>, url) {
		var script = document.createElement('script');
		script.type = "application/ld+json";
		// script.innerText = '{"@context": "http://schema.org","@type": "Organization","url":"'+ storeInfo.orderUrl +'","logo":"'+ storeInfo.orderUrl +'img/logo.png"}';
		var textData = '{';
		textData = textData + '"@context": "http://schema.org","@type": "ItemList", "itemListElement":[';
		for (var i = 0; i <= data.length - 1; i++) {
			if (i == 0) { textData = textData + '{'; } else { textData = textData + ', {'; }
			textData = textData + '"@type":"ListItem",';
			textData = textData + '"position":' + (i + 1) + ',';
			textData = textData + '"item": {';
			textData = textData + '"@type": "MenuItem",';
			textData = textData + '"url":"' + storeInfo.orderUrl + 'app/#/menu-item/' + data[i].title.split(' ').join('-') + ' /' + data[i].key + '",';
			textData = textData + '"name": "' + data[i].title + '",';
			textData = textData + '"image": "' + data[i].thumb + '",';
			textData = textData + '"description": "' + data[i].description + '" }';
			textData = textData + '}';
		}
		textData = textData + ']';
		textData = textData + '}';
		// console.log(textData);
		script.innerHTML = textData;
		document.getElementsByTagName('head')[0].appendChild(script);
	}
}


// WEBPACK FOOTER //
// ./src/providers/htmlhead-service/htmlhead-service.ts